<template>
    
    <div id="timepicker">
        <label for="schedule">Tid</label>
        <p class="error" v-if="no_times">
			Der er ingen ledige tidspunkter
		</p>
        <select id="schedule" required v-model="time_pick" @change="selectIt(time_pick)">
            <option v-for="t in times" :value="t">
                {{ t.h | prettyZero }}:{{ t.m | prettyZero}}
            </option>
        </select>
    </div>

</template>

<script>

    import axios from '../../utils/Http.js'
    import { leadZero, dateJs2django, makeTimeZoneOffsetStr, dateDjango2js, createDaySpan } from '../../utils/Filters.js'

    export default {
        props: {
            interval: {
                type: Number,
                default: 1800000 // default interval is 30 minutes in milliseconds
            },
            threeDayRule: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                time_pick: null,
                times: [],
                no_times: false
            }
        },
        filters: {
            prettyZero: function(x) {
                return leadZero(x)
            }
        },
        computed: {
            resource: function() {
                return this.$store.getters.getResource
            },
            startdatetime: function() {
				return this.$store.getters.getStartDateTime
            }
        },
        watch: {
            startdatetime: function() {
                this.update()
            }
        },
        methods: {
            update: function() {
                if (this.resource && this.startdatetime) {
                    this.time_pick = {
                        h: this.startdatetime.getHours(),
                        m: this.startdatetime.getMinutes()
                    }
                    let start = new Date( new Date(this.startdatetime).setHours(0,0) ),
                        end = new Date( new Date(this.startdatetime).setHours(23,59) )
                    axios({
                        url: `/booking/resource/${ this.resource.id }/availability/?start=${ encodeURIComponent(dateJs2django(start)) }&end=${ encodeURIComponent(dateJs2django(end)) }`,
                        method: 'get',
                        headers: {
                            'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                        }
                    })
                    .then(res => {
                        let trimmed_times = this.trimAvailableTimes(res.data)
                        this.times = []
                        if (Array.isArray(trimmed_times)) {
                            for (let t in trimmed_times) {
                                this.calcIntervals(trimmed_times[t])
                            }
                        }
                    })
                    .catch(err => console.log(err))
                }
            },
            trimAvailableTimes: function(avail_times) {
                // Trim available times so no times from the past are available
                let times_list = []
                let now = new Date().getTime()
                if (this.threeDayRule) {
                    now = now + 259200000
                }
                for (let t in avail_times) {
                    let time = {
                        start: dateDjango2js(avail_times[t].start).getTime(),
                        end: dateDjango2js(avail_times[t].end).getTime()
                    }
                    if (time.start < now) {
                        time.start = this.normalizeTime(now)
                    }
                    if (time.end > now) {
                        times_list.push(time)
                    }
                }
                return times_list
            },
            calcIntervals: function(timeobj) {
                let start = timeobj.start,
                    end = timeobj.end
                for (let s = start; s < end; s = s + this.interval) {
                    const time = new Date(s)
                    this.times.push({
                        h: time.getHours(),
                        m: time.getMinutes()
                    })
                }
            },
            normalizeTime(t) {
                let dt = new Date(t)
                if (dt.getMinutes() < 30) {
                    dt.setMinutes(30)
                } else if (dt.getMinutes() >  30) {
                    dt.setMinutes(0)
                    dt.setHours(dt.getHours() + 1)
                }
                return dt.getTime()
            },
            selectIt: function(t) {
                if (t) {
                    let dt = new Date( this.startdatetime )
                    dt = new Date( dt.setHours(t.h, t.m) )
                    this.$store.commit('setStartDateTime', dt)
                    this.$emit('time-pick', dt)
                }
            }
        },
        created: function() {
            this.update()
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #timepicker {

        .error {
            margin-bottom: 0;
        }
    }

</style>
